import { render, staticRenderFns } from "./qiniu_upload_btn.vue?vue&type=template&id=138876ca&"
import script from "./qiniu_upload_btn.vue?vue&type=script&lang=js&"
export * from "./qiniu_upload_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports